import { consentKeys, fetchConsentById, resolveConsentReadLocale } from "@/features/consent/api/selectConsentById";
import { diaryByIdQueryOptions } from "@/features/diaries";
import { useWorklistCopy } from "@/features/i18n/worklistCopy";
import { WorklistConsentPanel } from "@/features/worklist/components/WorklistConsentPanel";
import { createFileRoute, redirect } from "@tanstack/react-router";

function WorklistConsentPage() {
    const copy = useWorklistCopy();
    const { diaryId, consentId } = Route.useParams();
    const { diary, consent } = Route.useLoaderData();
    const patientName = diary?.patient_info?.patient_name?.trim() || copy.unknownPatient;
    const title = consent?.consent_name?.trim() || copy.consentTask;

    return <WorklistConsentPanel diaryId={diaryId} consentId={consentId} title={title} patientName={patientName} />;
}

export const Route = createFileRoute("/_app/worklist/consent/$diaryId/$consentId")({
    component: WorklistConsentPage,
    loader: async ({ context, params }) => {
        const locale = resolveConsentReadLocale();
        const [diary, consent] = await Promise.all([
            context.queryClient.ensureQueryData(diaryByIdQueryOptions(params.diaryId)),
            context.queryClient.ensureQueryData({
                queryKey: consentKeys.byId(params.consentId, locale),
                queryFn: () => fetchConsentById(params.consentId, locale),
            }),
        ]);

        if (!consent || consent.diary_id !== params.diaryId) {
            throw redirect({ to: "/worklist" });
        }

        return { diary, consent };
    },
});
